import script from "./QuanLyGopYKienNghi.vue?vue&type=script&setup=true&lang=js"
export * from "./QuanLyGopYKienNghi.vue?vue&type=script&setup=true&lang=js"

import "./QuanLyGopYKienNghi.vue?vue&type=style&index=0&id=24aa8d88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24aa8d88"]])

export default __exports__